import { Link } from 'react-router-dom';
import { Scale, Github, FileText } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';
import { BACKEND_URL } from '../../lib/api';

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t bg-muted/30" data-testid="footer">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-3">
              <Scale className="h-5 w-5 text-accent" />
              <span className="font-semibold" style={{ fontFamily: 'var(--font-heading)' }}>
                Canon Compass
              </span>
            </div>
            <p className="text-sm text-muted-foreground max-w-sm">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-medium mb-3 text-sm">{t('footer.explore')}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/library" className="hover:text-foreground transition-colors">{t('nav.library')}</Link></li>
              <li><Link to="/chat" className="hover:text-foreground transition-colors">{t('nav.ask')}</Link></li>
              <li><Link to="/case" className="hover:text-foreground transition-colors">{t('nav.caseTool')}</Link></li>
              <li><Link to="/learn" className="hover:text-foreground transition-colors">{t('nav.learn')}</Link></li>
              <li><Link to="/offline" className="hover:text-foreground transition-colors">{t('nav.offline')}</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-medium mb-3 text-sm">{t('footer.resources')}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/glossary" className="hover:text-foreground transition-colors">{t('footer.glossary')}</Link></li>
              <li><Link to="/rulebook" className="hover:text-foreground transition-colors">{t('footer.rulebook')}</Link></li>
              <li><a href={`${BACKEND_URL}/docs`} target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors flex items-center gap-1"><FileText className="h-3.5 w-3.5" /><span>{t('footer.apiDocs')}</span></a></li>
              <li><Link to="/changelog" className="hover:text-foreground transition-colors">{t('footer.changelog')}</Link></li>
              <li><Link to="/feedback" className="hover:text-foreground transition-colors">Feedback</Link></li>
              <li>
                <a href="#" className="hover:text-foreground transition-colors inline-flex items-center space-x-1">
                  <Github className="h-3.5 w-3.5" />
                  <span>{t('footer.sourceCode')}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t mt-8 pt-6 flex flex-col sm:flex-row justify-between items-center text-xs text-muted-foreground">
          <p>{t('footer.copyright')}</p>
          <p className="mt-2 sm:mt-0">
            © 2026{' '}
            <a
              href="https://alphasynthai.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors"
            >
              AlphaSynth AI
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
